import { isEqual } from 'lodash';
import { useRef } from 'react';

export default function useEqual(value: any) {
  const ref = useRef(null);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
